export const priceBadgeStyles = {
  root: "flex items-center gap-0.5 rounded-full bg-white px-1 py-0.5",
  value: "text-2xl/none font-semibold tracking-[-0.5px] text-black-100",
  icon: "text-black-100",
} as const
